// extracted by mini-css-extract-plugin
export default {"certificate":"certificate_certificate__oZ5yL","text":"certificate_text__vdEiz","btn":"certificate_btn__kLtjv"};